import { NavLink } from "react-router-dom";
import { ShoppingCart, PackageCheck } from "lucide-react";

const TABS = [
    { to: "/dashboard/indkoebsliste", label: "Indkøbsliste", icon: ShoppingCart, testid: "tab-indkoebsliste" },
    { to: "/dashboard/leveringscheckliste", label: "Leveringscheckliste", icon: PackageCheck, testid: "tab-levering" },
];

export default function IndkoebTabs() {
    return (
        <div className="mb-4 border-b border-slate-200 flex flex-wrap gap-1" data-testid="indkoeb-tabs">
            {TABS.map((t) => (
                <NavLink
                    key={t.to}
                    to={t.to}
                    end
                    data-testid={t.testid}
                    className={({ isActive }) =>
                        `inline-flex items-center gap-1.5 px-4 py-2.5 text-sm font-medium border-b-2 -mb-px transition-colors ${
                            isActive ? "border-blue-600 text-blue-700" : "border-transparent text-slate-500 hover:text-slate-900"
                        }`
                    }
                >
                    <t.icon className="w-4 h-4" /> {t.label}
                </NavLink>
            ))}
        </div>
    );
}
